import { QueryClient } from "@tanstack/react-query";

/**
 * 공유 QueryClient 인스턴스
 * Canvas 내부와 외부에서 동일한 QueryClient를 사용하기 위해 별도 파일로 분리
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60, // 1분
    },
  },
});
